angular.module("siter.io").controller "Dashboard", ["$scope", "$rootScope", "$state", "$timeout", "Site", "Modal", "Template", "$location", "Section", "Widget", "Notification", "Email", ($scope, $rootScope, $state, $timeout, Site, Modal, Template, $location, Section, Widget, Notification, Email) ->

  $scope.state = $state

  if window.justclick.currentUser.role is "client"
    $location.path '/404'

  $scope.currentState = $state.current.name
  $scope.tagobject = {tagName:""}
  $scope.scrollDisabled = false
  $scope.addSite = Site.addSite

  $rootScope.site = {}

  $scope.getHomePagePath = (pages) ->
    return false if pages.length is 0
    homePage = _.filter pages, home: true
    homePage[0].path

  $rootScope.refreshTemplates = ->
    $scope.sitesLoading = true
    Template.getAll().then (sites) ->
      $scope.sites = sites
      $scope.sitesCount = sites.length
      $scope.sitesLoading = false

  $scope.emails = []

  $rootScope.refreshEmailTemplates = ->
    $scope.emailsLoading = true
    Template.getEmailTemplates().then (emails) ->
      $scope.emails = emails
      $scope.emailsCount = emails.length
      $scope.emailsLoading = false

  $scope.sectionsLoading = true

  #load sections for site

  Section.getSections().then (sections) ->
    $scope.sections = sections.sections
    $scope.sectionsLoading = false

  refreshTags = ->
    Template.getUserCategories().then (tags) ->
      $scope.templatesTags = tags

  refreshTags()

  $scope.treeOptions =
    dropped: (e) ->
      $timeout ->
        Template.sortCategories($scope.templatesTags).then (tags) ->
          $scope.templatesTags = tags
      return

  refreshEmailTags = ->
    Template.getEmailUserCategories().then (tags) ->
      $scope.emailTemplatesTags = tags

  refreshEmailTags()

  $scope.treeEmailOptions =
    dropped: (e) ->
      $timeout ->
        Template.sortEmailCategories($scope.emailTemplatesTags).then (tags) ->
          $scope.emailTemplatesTags = tags
      return

  $scope.emailSectionsLoading = true

  #load sections for email

  Section.getSections(true).then (sections) ->
    $scope.emailSections = sections.sections
    $scope.emailSectionsLoading = false


  $scope.imagesLoading = true

  $scope.getImages = ->
    Widget.getImages().then (images) ->
      $scope.imagesData = images
      $scope.imagesLoading = false

  $scope.getImages()

  $scope.searchImages = (tag) ->
    Widget.getImagesByTag(tag, "").then (data) ->
      $scope.imagesData = data

  Widget.getImagesTags().then (data) ->
    $scope.imagesTags = data


  $scope.saveImage = (image) ->
    Widget.updateImage(image)

  $scope.getNextImages = ->
    if $scope.imagesData.pagination.itemCount <= $scope.imagesData.images.length then return false
    $scope.scrollDisabled = true
    lastId = $scope.imagesData.images[$scope.imagesData.images.length-1].id
    Widget.getImagesByTag($scope.tagobject.tagName, lastId).then (imagesData) ->
      $scope.imagesData.images = $scope.imagesData.images.concat imagesData.images
      if imagesData.images.length > 0
        $scope.scrollDisabled = false
      else
        $scope.scrollDisabled = true
    return


  $scope.propertyName = 'name'
  $scope.reverse = true

  $scope.sortBy = (propertyName) ->
    $scope.reverse = if ($scope.propertyName is propertyName) then !$scope.reverse else false;
    $scope.propertyName = propertyName


  $scope.remove = (collection, site) ->
    findedSite = _.filter collection, {id: site.id}
    index = collection.indexOf findedSite[0]
    $rootScope.alertDialog
      title: "Deleting a template"
      text: "Are you sure you want to delete this template?"
      accept_text: "Yes"
      cancel_text: "Cancel"
      accept: ->
        Site.remove(site.id).then ->
          collection.splice index, 1
          refreshTags()


  $scope.removeEmailTemplate = (collection, site) ->
    findedSite = _.filter collection, {id: site.id}
    index = collection.indexOf findedSite[0]
    $rootScope.alertDialog
      title: "Deleting a message template"
      text: "Are you sure you want to delete this message template?"
      accept_text: "Yes"
      cancel_text: "Cancel"
      accept: ->
        Email.remove(site.id).then ->
          collection.splice index, 1

  $scope.removeImage = (collection, image) ->
    findedImage = _.filter collection, {id: image.id}
    index = collection.indexOf findedImage[0]
    $rootScope.alertDialog
      title: "Deleting image"
      text: "Are you sure you want to delete this image?"
      accept_text: "Yes"
      cancel_text: "Cancel"
      accept: ->
        Widget.remove(image).then ->
          collection.splice index, 1
          Notification.success message: 'Image successfully deleted'

  $scope.removeSection = (section, collection) ->
    findedSection = _.filter collection, {id: section.id}
    index = collection.indexOf findedSection[0]
    $rootScope.alertDialog
      title: "Deleting a section"
      text: "Are you sure you want to delete this section?"
      accept_text: "Yes"
      cancel_text: "Cancel"
      accept: ->
        Section.removePublic(section.id).then ->
          collection.splice index, 1


  $scope.saveTemplate = (template) ->
    Site.update template

  $scope.saveEmailTemplate = (template) ->
    Email.update template

  $scope.saveSection = (section) ->
    Section.savePublic section

  # listeners

  listener0 = $rootScope.$on "site:updated", (e, newsite, template = false) ->
    refreshTags()

  listener = $rootScope.$on "site:created", (e, newsite, template = false) ->
    if template
      template.childs.push newsite
    else
      $scope.sites.push newsite
    refreshTags()

  listener2 = $rootScope.$on "image:created", (e, newimage) ->
    $scope.imagesData.images.push newimage

  listener3 = $rootScope.$on "email:created", (e, newemail, template = false) ->
    if template
      template.childs.push newemail
    else
      $scope.emails.push newemail
    refreshEmailTags()

  listener4 = $rootScope.$on "email:updated", (e, newsite, template = false) ->
    refreshEmailTags()

  $rootScope.refreshTemplates()
  $rootScope.refreshEmailTemplates()

  $scope.$on "$destroy", ->
    listener0()
    listener()
    listener2()
    listener3()
    listener4()

  # modals
  $scope.createSectionModal = Modal.createSectionModal
  $scope.editSectionModal = Modal.editSectionModal
  $scope.createEmailSectionModal = Modal.createEmailSectionModal
  $scope.editEmailSectionModal = Modal.editEmailSectionModal
  $scope.newTemplate = Modal.newTemplate
  $scope.editTemplate = Modal.editTemplate
  $scope.newEmailTemplate = Modal.newEmailTemplate
  $scope.editEmailTemplate = Modal.editEmailTemplate
  $scope.editImage = Modal.editImage
  $scope.newImage = Modal.newImage

]



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.controller.coffee